import Set from 'es6-set'

import { PurchaseOrderComponent } from '../Features/PaymentMethod'

// BBS DDD 2017-11-28 From https://stackoverflow.com/questions/19655975/check-if-an-array-contains-duplicate-values
const isAllUniqueValues = (list) => {
  const len = list.length;
  const size = new Set(list).size;
  return len === size;
}

const shippingOptionsAreInvalid = (shippingOptions) => {
  if (!isAllUniqueValues(shippingOptions.map(so => so.Id))) {
    console.error('not all Ids unique for ShippingOptions');
    return true;
  }
}

const cartItemsAreInvalid =(cartItems) => {
  if (!isAllUniqueValues(cartItems.map(ci => ci.Id))) {
    console.error('not all Ids unique for CartItems');
    return true;
  }
}

const paymentOptionsAreInvalid = (paymentOptions) => {
    if (!isAllUniqueValues(paymentOptions.map(po => po.Id))) {
        console.error('not all Ids unique for PaymentOptions');
        return true;
      }
  }

// Perhaps https://validatejs.org/ would be useful here
const initialDataIsInvalid = (initialData) => {
  // BBS DDD 2018-03-07 Don't validate address id uniqueness. Addresses can be of multiple types
  //let addresses = initialData.BillingAddresses.concat(initialData.ShippingAddresses);
  //if (addressesAreInvalid(addresses)) {
  //  return true;
  //}
  if (shippingOptionsAreInvalid(initialData.ShippingOptions)) {
    return true;
  }
  if (cartItemsAreInvalid(initialData.CartItems)) {
    return true;
  }
  if (paymentOptionsAreInvalid(initialData.PaymentOptions)) {
        return true;
      }

}

const mapTopLevelPropsToInitialStoreState = props => {
  // validate
  if (initialDataIsInvalid(props.initialData)) {
    return {};
  };

  // Add controls to payment if they have one
    const paymentOptions = props.initialData.PaymentOptions.map(po => {
        if (po.Id === props.purchaseOrderPaymentId) {
            po.paymentOptionComponent = PurchaseOrderComponent;
        }
        return po;
      });
  
      let selectedPaymentOption = paymentOptions.find(po => po.IsSelected);
    if (!selectedPaymentOption) {
        selectedPaymentOption = paymentOptions[0];
      }

  const allowBillingEqualsShipping = props.initialData.AllowBillingEqualsShipping;
  const selectedShippingAddressId = props.initialData.ShippingAddresses[0] && props.initialData.ShippingAddresses[0].Id;
  const selectedBillingAddressId = (allowBillingEqualsShipping && selectedShippingAddressId)
    ? (selectedShippingAddressId)
    : (props.initialData.BillingAddresses[0] && props.initialData.BillingAddresses[0].Id);
  return {
    // BBS DDD 2017-11-19 The state of the ui. Make all ui updates here.
    ui: {
      PhoneNumber: props.initialData.PhoneNumber,
      PhoneText: props.initialData.PhoneText,
      useShippingForBilling: allowBillingEqualsShipping,
      messages: [],
      completeCheckoutButtonText: "Submit Request for Quote",
      isPlaceOrderPending: false
    },
    // BBS DDD 2017-11-19 The state of the checkout. Make all business
    // updates here
    entities: {
      Addresses: props.initialData.BillingAddresses.concat(props.initialData.ShippingAddresses),
      BillingAddresses: props.initialData.BillingAddresses.map(addr => addr.Id),
      SelectedBillingAddressId: selectedBillingAddressId,
      ShippingAddresses: props.initialData.ShippingAddresses.map(addr => addr.Id),
      SelectedShippingAddressId: selectedShippingAddressId,
      CartItems: props.initialData.CartItems,
      SelectedPaymentOptionId: selectedPaymentOption && selectedPaymentOption.Id || '',
      PaymentOptions: paymentOptions
    },
    // BBS DDD 2017-11-19 Data definitions and other things
    constants: {
      // Locations of server resources
      navigation: {
        MyAccountLink: '',
        checkoutUrl: props.checkoutUrl,
        ReceiptUrl: props.initialData.ReceiptUrl,
        addAddressEndpoint: props.addAddressEndpoint,
        deleteAddressEndpoint: props.deleteAddressEndpoint,
        placeOrderEndpoint: props.placeOrderEndpoint,
        orderConfirmationUrl: props.orderConfirmationUrl,
        updateItemQuantityEndpoint: props.updateQuantityEndpoint,
        deleteItemEndpoint: props.deleteItemEndpoint
      },
      ShippingAddressType: props.ShippingAddressType,
      BillingAddressType: props.BillingAddressType,
      countriesStatesMap: props.countriesStatesMap,
      countries: props.countries,
      allowBillingEqualsShipping: props.initialData.allowBillingEqualsShipping,
      purchaseOrderPaymentId: props.purchaseOrderPaymentId,
      cartName: props.CartName
    }
  }
}


export default mapTopLevelPropsToInitialStoreState